function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _regeneratorRuntime() {
    "use strict";
    var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); }
    var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 };
    function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try {
        return r(_t, o);
    }
    finally {
        e.next = n.n;
    } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try {
        return r.call(this, e);
    }
    finally {
        n.p = e.prev, n.n = e.next;
    } }; }
    return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })();
}
function _regeneratorValues(e) { if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
    if (t)
        return t.call(e);
    if ("function" == typeof e.next)
        return e;
    if (!isNaN(e.length))
        return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } };
} throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n)
    r.unshift(t); return function e() { for (; r.length;)
    if ((t = r.pop()) in n)
        return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try {
    var c = t[r](o), u = c.value;
    return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); });
}
catch (t) {
    f(t);
} } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { createContext, useContext, useEffect, useState } from 'react';
import { apiClient } from '@/services/api';
import { jsx as _jsx } from "react/jsx-runtime";
var AuthContext = /*#__PURE__*/ createContext(undefined);
export var AuthProvider = function AuthProvider(_ref) {
    var children = _ref.children;
    var _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), user = _useState2[0], setUser = _useState2[1];
    var _useState3 = useState(true), _useState4 = _slicedToArray(_useState3, 2), loading = _useState4[0], setLoading = _useState4[1]; // загрузка профиля при старте
    var _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), error = _useState6[0], setError = _useState6[1];
    var fetchProfile = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(options) {
            var silent, res;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            silent = (options === null || options === void 0 ? void 0 : options.silent) === true;
                            if (!silent) {
                                setLoading(true);
                            }
                            setError(null);
                            _context.prev = 3;
                            _context.next = 6;
                            return apiClient.profile.profileGet();
                        case 6:
                            res = _context.sent;
                            setUser(res.data);
                            _context.next = 13;
                            break;
                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context["catch"](3);
                            setUser(null);
                        case 13:
                            _context.prev = 13;
                            if (!silent) {
                                setLoading(false);
                            }
                            return _context.finish(13);
                        case 16:
                        case "end":
                            return _context.stop();
                    }
            }, _callee, null, [[3, 10, 13, 16]]);
        }));
        return function fetchProfile(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    useEffect(function () {
        void fetchProfile();
    }, []);
    var login = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(data) {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1)
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            setError(null);
                            _context2.prev = 1;
                            _context2.next = 4;
                            return apiClient.auth.authLoginPost(data);
                        case 4:
                            _context2.next = 6;
                            return fetchProfile();
                        case 6:
                            _context2.next = 13;
                            break;
                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2["catch"](1);
                            setUser(null);
                            setError(_context2.t0 instanceof Error ? _context2.t0.message : 'Ошибка авторизации');
                            throw _context2.t0;
                        case 13:
                        case "end":
                            return _context2.stop();
                    }
            }, _callee2, null, [[1, 8]]);
        }));
        return function login(_x2) {
            return _ref3.apply(this, arguments);
        };
    }();
    var register = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee3(data) {
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1)
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            setError(null);
                            _context3.prev = 1;
                            _context3.next = 4;
                            return apiClient.user.userPost(data);
                        case 4:
                            _context3.next = 10;
                            break;
                        case 6:
                            _context3.prev = 6;
                            _context3.t0 = _context3["catch"](1);
                            setError(_context3.t0 instanceof Error ? _context3.t0.message : 'Ошибка регистрации');
                            throw _context3.t0;
                        case 10:
                        case "end":
                            return _context3.stop();
                    }
            }, _callee3, null, [[1, 6]]);
        }));
        return function register(_x3) {
            return _ref4.apply(this, arguments);
        };
    }();
    var logout = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee4() {
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1)
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            setError(null);
                            _context4.prev = 1;
                            _context4.next = 4;
                            return apiClient.auth.authLogoutGet();
                        case 4:
                            setUser(null);
                            _context4.next = 11;
                            break;
                        case 7:
                            _context4.prev = 7;
                            _context4.t0 = _context4["catch"](1);
                            setError(_context4.t0 instanceof Error ? _context4.t0.message : 'Ошибка выхода');
                            throw _context4.t0;
                        case 11:
                        case "end":
                            return _context4.stop();
                    }
            }, _callee4, null, [[1, 7]]);
        }));
        return function logout() {
            return _ref5.apply(this, arguments);
        };
    }();
    var reloadProfile = /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee5() {
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                while (1)
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return fetchProfile({
                                silent: true
                            });
                        case 2:
                        case "end":
                            return _context5.stop();
                    }
            }, _callee5);
        }));
        return function reloadProfile() {
            return _ref6.apply(this, arguments);
        };
    }();
    var value = {
        user: user,
        loading: loading,
        isAuth: !!user,
        error: error,
        login: login,
        logout: logout,
        register: register,
        reloadProfile: reloadProfile
    };
    return /*#__PURE__*/ _jsx(AuthContext.Provider, {
        value: value,
        children: children
    });
};
export var useAuthContext = function useAuthContext() {
    var ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error('useAuthContext должен использоваться внутри <AuthProvider>');
    }
    return ctx;
};
